import { addFilter, removeFilter } from '@wordpress/hooks';
import InventoryTabContent from './InventoryTabContent'

const InventoryTabContentCB = ( content, allData ) => {
    return [ ...content, <InventoryTabContent allData={allData} /> ];
}

// Hooks.
removeFilter( 'wptravel_trip_edit_tab_content_inventory_options', 'WPTravel/TripEdit/InventoryNotice' );
addFilter( 'wptravel_trip_edit_tab_content_inventory_options', 'WPTravelPro\TripEdit\InventoryTabContent', InventoryTabContentCB, 10 );